const ForwardIcons = ({ className }) => {
	return (
		<svg
			className={className ? className : "inline mx-2"}
			width="16"
			height="16"
			viewBox="0 0 14 12"
			fill="#6F767E"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="#6F767E"
				clip-rule="#6F767E"
				d="M9.25724 0.207104C9.52689 -0.0690348 9.96408 -0.0690348 10.2337 0.207104L13.4641 3.51517C13.5936 3.64777 13.6663 3.82763 13.6663 4.01516C13.6663 4.2027 13.5936 4.38255 13.4641 4.51516L10.2337 7.82322C9.96408 8.09936 9.52689 8.09936 9.25724 7.82322C8.98758 7.54708 8.98758 7.09937 9.25724 6.82323L11.3089 4.72226H3.60779C3.10552 4.72226 2.62383 4.92658 2.26867 5.29028C1.91351 5.65398 1.71399 6.14726 1.71399 6.66161V11.2929C1.71399 11.6834 1.40485 12 1.0235 12C0.642151 12 0.333008 11.6834 0.333008 11.2929V6.66161C0.333008 5.7722 0.678028 4.91921 1.29217 4.2903C1.90631 3.66138 2.73926 3.30806 3.60779 3.30806L11.3089 3.30806L9.25724 1.20709C8.98758 0.930954 8.98758 0.483244 9.25724 0.207104Z"
				fill="#33383F"
			/>
		</svg>
	);
};

export default ForwardIcons;
